// Pequenos helpers para formatação de datas sem depender de date-fns/locale (ESM),
// o que quebra Jest/CRA ao importar de node_modules.

const PT_LOCALE = 'pt-PT';

function asDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatPtLongDate(value) {
  const d = asDate(value) || new Date();
  return new Intl.DateTimeFormat(PT_LOCALE, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(d);
}

export function formatPtWeekday(value, { short = false } = {}) {
  const d = asDate(value) || new Date();
  return new Intl.DateTimeFormat(PT_LOCALE, {
    weekday: short ? 'short' : 'long'
  }).format(d);
}

export function formatPtDayMonth(value, { shortMonth = false } = {}) {
  const d = asDate(value) || new Date();
  return new Intl.DateTimeFormat(PT_LOCALE, {
    day: 'numeric',
    month: shortMonth ? 'short' : 'long'
  }).format(d);
}

export function formatPtMonthYear(value) {
  const d = asDate(value) || new Date();
  return new Intl.DateTimeFormat(PT_LOCALE, {
    month: 'long',
    year: 'numeric'
  }).format(d);
}

export function formatYear(value) {
  const d = asDate(value) || new Date();
  return new Intl.DateTimeFormat(PT_LOCALE, { year: 'numeric' }).format(d);
}

export function formatDDMMYYYY(value) {
  const d = asDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat(PT_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
}

export function formatDDMonYYYY(value) {
  const d = asDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat(PT_LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
    .format(d)
    .replace(/\./g, ''); // pt-PT costuma vir com "." no mês abreviado
}

export function formatHHMM(value) {
  const d = asDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat(PT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(d);
}

export function formatHHMMSS(value) {
  const d = asDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat(PT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(d);
}


